import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button, Slide, useTheme, useMediaQuery, Typography
} from '@mui/material';

import PropTypes from 'prop-types';
import currencyLocalMessages from './messages/LocaleCurrencyMessages';
import { trackButtonClick } from '../segment/segmentModule';
import { PDP_STEP } from '../routing/flowConstants';


const Transition = React.forwardRef((props, ref) => <Slide direction='up' ref={ref} {...props} />);

const CartCurrencyPresentPopUp = ({
    intl, isOpen, handleCloseModel, message, trackAddAnotherButton
}) => {
    const handleClose = () => {
        handleCloseModel(false);
    };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Dialog
            fullWidth
            maxWidth='sm'
            open={isOpen}
            TransitionComponent={isMobile ? Transition : undefined}
            onClose={handleClose}
            className='switch-currency-dialog switch-cart-currency-dialog'
        >
            <DialogContent className='switch-cart-currency-content'>
                <Typography className='switch-cart-currency-content-text' variant='caption' style={{ whiteSpace: 'pre-line' }}>
                    {message}
                </Typography>
            </DialogContent>
            <DialogActions className='switch-currency-actions'>
                <Button
                    className='switch-currency-button'
                    variant='outlined'
                    onClick={() => {
                        handleClose();
                        trackAddAnotherButton('Got It', PDP_STEP, 'info_popup');
                    }}
                >
                    {intl.formatMessage(currencyLocalMessages.gotItButtonText)}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

CartCurrencyPresentPopUp.propTypes = {
    
    intl: intlShape.isRequired,
    isOpen: PropTypes.bool.isRequired,
    handleCloseModel: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
    trackAddAnotherButton: PropTypes.func.isRequired
};

const mapDispatchToProps = {
    trackAddAnotherButton: trackButtonClick
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CartCurrencyPresentPopUp));
